// TODO - this array is mutated by users. This should be changed as this is global state.
const dateSelections = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "7days", label: "Last 7 Days + today" },
  { value: "last_7days", label: "Last 7 Days" },
  { value: "30days", label: "Last 30 Days + today" },
  { value: "last_30days", label: "Last 30 Days" },
  { value: "month", label: "This Month" },
  { value: "quarter", label: "This Quarter" },
  { value: "year", label: "This Year" },
  { value: "last_month", label: "Last Month" },
  { value: "last_quarter", label: "Last Quarter" }
];

export default dateSelections;
